// Identidade de visitante e sessão — anônima mas persistente.
//
// - `visitor_id`: mora em localStorage, sobrevive a fechamentos de aba/navegador.
//   Serve para reconhecer quem *voltou* ao site em dias diferentes.
// - `session_id`: mora em sessionStorage, é regenerado sempre que a aba é
//   fechada. Serve para agrupar a jornada de UMA visita (clicks, scroll,
//   tempo em artigo) em um bloco coerente.
//
// Nenhum dos dois carrega dado pessoal — são UUIDs opacos gerados no cliente.

const uuid = () => {
    if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
    // Fallback simples — não precisa de força criptográfica aqui
    return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};

const safeGet = (storage, key) => {
    try {
        return storage.getItem(key);
    } catch (_e) {
        return null;
    }
};
const safeSet = (storage, key, value) => {
    try {
        storage.setItem(key, value);
    } catch (_e) {
        /* privacy mode / disabled — silently ignore */
    }
};

export const getVisitorId = () => {
    if (typeof window === "undefined") return "anon";
    let v = safeGet(window.localStorage, "rl_visitor");
    if (!v) {
        v = uuid();
        safeSet(window.localStorage, "rl_visitor", v);
    }
    return v;
};

export const getSessionId = () => {
    if (typeof window === "undefined") return "anon-session";
    let s = safeGet(window.sessionStorage, "rl_session");
    if (!s) {
        s = uuid();
        safeSet(window.sessionStorage, "rl_session", s);
    }
    return s;
};

// Retorna true APENAS na primeira chamada por sessão. Serve para disparar
// o evento `session_start` (com referrer / utm) exatamente uma vez.
export const isFirstEventOfSession = () => {
    if (typeof window === "undefined") return false;
    const flag = safeGet(window.sessionStorage, "rl_session_started");
    if (flag) return false;
    safeSet(window.sessionStorage, "rl_session_started", "1");
    return true;
};

// Extrai parâmetros UTM (+ gclid/fbclid) da URL atual.
export const parseUtms = () => {
    if (typeof window === "undefined") return {};
    const q = new URLSearchParams(window.location.search);
    const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid", "fbclid"];
    const out = {};
    for (const k of keys) {
        const v = q.get(k);
        if (v) out[k] = v.slice(0, 80);
    }
    return out;
};
